<div
  class="modal fade"
  id="ocausDocument"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLongTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Document Upload</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body modal-lg">
        <div style="width: 99%; min-height: 470px">
          <pdf-viewer
            *ngIf="pdfSrc"
            [src]="pdfSrc"
            [render-text]="true"
            style="display: block"
            [original-size]="false"
            [autoresize]="true"
          ></pdf-viewer>
          <img [src]="img" *ngIf="img" />
          <ngx-loading [show]="isLoading"></ngx-loading>
        </div>

        <div style="width: 99%; min-height: 470px" class="text-center"></div>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn_primary"
          type="button"
          class="close"
          data-dismiss="modal"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="col-12"
  *ngIf="isLoading"
  style="
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
  "
>
  <app-progress></app-progress>
</div>

<div class="ocas_questionnaire_page">
  <div class="inner_wrapper">
    <div>
      <h1 class="page_heading">Carrier Account</h1>
      <!-- <p class="user_account">patrix@praxis.co.za</p> -->
    </div>
    <p class="subheading">
      Please answer the following questions about your management systems. If
      you answer yes, please provide an explanation and documentary evidence
      using the document upload features.
    </p>
    <p class="subheading year">Year 2023-2024</p>

    <form
      [formGroup]="questionnairesForm"
      *ngIf="questionnaires && questionnaires.length"
      (ngSubmit)="questionnairesHandler()"
    >
      <ul class="questions_list"  *ngFor="let question of questionnaires.controls; let i = index">
        <li
          class="question_list_item"
         
          *ngIf="questionsData[i].Ocas_Type.group_code != 'AUDIT' && !questionsData[i].disabled"
        >
          <div class="header" >
            {{ questionsData[i]?.Ocas_Type?.description }}
          </div>
          <ng-container [formGroup]="question">
            <div class="radio_buttons_wrapper" >
              <div class="radio_btn_wrap">
                <input
                  type="radio"
                  [value]="'YES'"
                  formControlName="answer"
                  (change)="handleYesAnswer($event, i)"
                />
                <label for="yes">YES</label>
              </div>
              <div class="radio_btn_wrap">
                <input
                  (change)="handleNoAnswer($event, i)"
                  type="radio"
                  [value]="'NO'"
                  formControlName="answer"
                />
                <label for="no">NO</label>
              </div>
            </div>

            <div
              *ngIf="question.controls.answer.value == 'YES'"
              class="question_body"
            >
              <textarea
                name="clarification"
                id="clarification"
                class="form-control textarea"
                formControlName="note"
                placeholder="Enter clarification"
                rows="10"
              ></textarea>
              <div class="dropzone" fileDragDrop>
                <div class="file_upload_wrapper">
                  <img src="/assets/upload_icon.png" alt="Upload icon" />
                  <input
                    type="file"
                    id="upload_file"
                    class="file_upload_input"
                    title=""
                    (change)="pushFileIntoQuestion($event, i)"
                  />
                  <label for="upload_file">
                    Drag and drop files here or click to search on your computer
                  </label>
                  <span class="upload_file_text">Upload file</span>
                </div>
              </div>
              <span class="max_limit">Max file size 5MB PDF format.</span>
              <div
                class="uploaded_files_wrapper"
                *ngIf="
                  question.controls.files.value &&
                  question.controls.files.value.length
                "
              >
                <h2>
                  Files To Be Uploaded ({{
                    question.controls.files.value.length
                  }})
                </h2>
                <ul class="uploaded_files_list">
                  <li
                    *ngFor="
                      let file of question.controls.files.value;
                      let filedIdx = index
                    "
                  >
                    <span class="name">{{ file | fileDetails : "NAME" }}</span>
                    <span class="type">{{ file | fileDetails : "TYPE" }}</span>
                    <span class="file_size">{{
                      file | fileDetails : "SIZE"
                    }}</span>
                    <div class="actions">
                      <!-- <button
                        type="button"
                        class="btn_icon"
                        aria-label="View file"
                        (click)="viewFileFormQuestion(i, filedIdx)"
                      >
                        <img src="assets/visibility.png" alt="" />
                      </button> -->
                      <button
                        (click)="removeFileFromQuestion(i, filedIdx)"
                        type="button"
                        class="btn_icon"
                        aria-label="Delete file"
                      >
                        <img
                          style="height: 14px"
                          src="assets/delete.png"
                          alt=""
                        />
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
              <!-- *ngIf="showDocument?.length > 0 && showTableData == userCreated" -->
              <div>
                <!-- start -->
                <div class="uploaded_files_wrapper">
                  <h2>
                    Files Uploaded ({{
                      getTotalFiles(
                        showDocument,
                        questionsData[i].Ocas_Type.id
                      )
                    }})
                  </h2>
                  <ul class="uploaded_files_list">
                    <ng-container *ngFor="let data of showDocument">
                      <li
                        *ngIf="
                          questionsData[i].Ocas_Type.id === data?.Ocas_Type.id
                        "
                      >
                        <ng-container>
                          <span class="name">
                            {{ data?.Document.file_name }}
                          </span>
                          <span class="type">
                            {{
                              data?.Document.ocument_type != null
                                ? data?.Document.ocument_type
                                : "PDF"
                            }}</span
                          >
                          <!-- <span class="file_size">{{
                      file | fileDetails : "SIZE"
                    }}</span> -->
                          <div class="actions">
                            <button
                              data-toggle="modal"
                              data-target="#ocausDocument"
                              aria-label="View file"
                              type="button"
                              class="btn_icon"
                              aria-label="View file"
                              (click)="
                                viewDoc(
                                  data?.Document.document_link,
                                  data?.Document.file_name
                                )
                              "
                            >
                              <img src="assets/visibility.png" alt="" />
                            </button>
                            <button
                              (click)="removeUploadedFile(data?.Document)"
                              type="button"
                              class="btn_icon"
                              aria-label="Delete file"
                            >
                              <img
                                style="height: 14px"
                                src="assets/delete.png"
                                alt=""
                              />
                            </button>
                          </div>
                        </ng-container>
                      </li>
                    </ng-container>
                  </ul>
                </div>
                <!-- end -->
              </div>
            </div>
          </ng-container>
        </li>
      </ul>
      <div class="action_btns" style="display: none;">

        <div class="btn_wrap">
          <a [routerLink]="['/carrier/accounts/VCA']" type="button" class="btn btn_secondary">Close</a>
        </div>

        <div class="btn_wrap">
          <button type="submit" class="btn btn_primary" id="saveQuesOcas">Save</button>
        </div>

        <div class="btn_wrap">
          <button type="button" class="btn btn_secondary" (click)="next()">Go to Depots</button>
        </div>
        <div class="btn_wrap" *ngIf="isInStepper">
          <button type="button" (click)="prevStep()" class="btn btn_primary">Back</button>
        </div>

      </div>
    </form>
  </div>
</div>
